import { memo, useEffect, useState } from 'react'

import CustomPopover, { CustomPopoverProps } from '@components/CustomPopover'

import AddNewShortlistSection, { AddNewShortlistSectionProps } from '.'
import { PopoverInner } from '../ShortlistProfileButton/index.styles'

const AddNewShortlistSectionPopover = (props: AddNewShortlistSectionProps & { anchor: CustomPopoverProps['anchor'] }) => {
  const { anchor, shortlists, isUniqueName, onCancel, onSuccess } = props

  const [editedValue, setEditedValue] = useState('')

  useEffect(() => {
    setEditedValue('')
  }, [anchor])

  return (
    <CustomPopover id="shortlist_popover" anchor={anchor} setAnchor={() => onCancel(editedValue)}>
      <PopoverInner width={270}>
        <AddNewShortlistSection
          isUniqueName={isUniqueName}
          shortlists={shortlists}
          onCancel={onCancel}
          onSuccess={onSuccess}
          onChange={setEditedValue}
        />
      </PopoverInner>
    </CustomPopover>
  )
}

export default memo(AddNewShortlistSectionPopover)
